import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  colorLandingBlue,
  colorLandingInk,
  colorLandingLine,
  colorLandingMuted,
  colorLandingSurface,
} from "src/design/tokens";

/** Four headline KPIs shown for the advanced analytics tab. */
export const AnalyticsMedia = () => {
  const { t } = useTranslation();

  const kpis = [
    { value: "86%", labelKey: "landingPage.showcase.analytics.occupancyRate" },
    { value: "562", labelKey: "landingPage.showcase.analytics.coversPerWeek" },
    { value: "3,1", labelKey: "landingPage.showcase.analytics.avgPartySize" },
    {
      value: t("landingPage.showcase.analytics.bestDayValue"),
      labelKey: "landingPage.showcase.analytics.bestDay",
      accent: true,
    },
  ];

  return (
    <Grid container spacing={1.25} sx={{ width: "100%" }}>
      {kpis.map((kpi) => (
        <Grid item xs={6} key={kpi.labelKey}>
          <Box
            sx={{
              backgroundColor: colorLandingSurface,
              border: `1px solid ${colorLandingLine}`,
              borderRadius: "11px",
              px: 1.875,
              py: 1.625,
              height: "100%",
            }}
          >
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: 26,
                lineHeight: 1,
                letterSpacing: "-0.02em",
                color: kpi.accent ? colorLandingBlue : colorLandingInk,
              }}
            >
              {kpi.value}
            </Typography>
            <Typography sx={{ fontSize: 11.5, color: colorLandingMuted, mt: 0.625 }}>
              {t(kpi.labelKey)}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
